// extracted by mini-css-extract-plugin
export default {"tableHeadContainer":"TableHeadStat_tableHeadContainer__vONz6","arrowDown":"TableHeadStat_arrowDown__hOUFL"};